<p-tabs [value]="activeTab()" (valueChange)="activeTab.set($event)">
    <p-tablist>
        <p-tab value="default">
            <i class="pi pi-th-large mr-2"></i>
            {{ 'packages.pricing.tab.default' | translate }}
        </p-tab>
        <p-tab value="custom">
            <i class="pi pi-cog mr-2"></i>
            {{ 'packages.pricing.tab.custom' | translate }}
            <span class="badge">{{ customPricingList().length }}</span>
        </p-tab>
    </p-tablist>

    <p-tabpanels>
        <p-tabpanel value="default">
            <p class="hint">{{ 'packages.pricing.tab.default.hint' | translate }}</p>
            <app-tier-pricing-editor [tiers]="pricingList()" testId="packages-pricing-tiers" />
        </p-tabpanel>

        <p-tabpanel value="custom">
            <p class="hint">{{ 'packages.pricing.tab.custom.hint' | translate }}</p>

            <app-custom-pricing-list
                [customPricingList]="customPricingList()"
                [pricingEntities]="pricingEntities()"
                testId="packages-pricing-custom"
                (editCustom)="openEditDialog($event)"
                (removeCustom)="removeCustom($event)"
            />

            <p-button
                [label]="'packages.pricing.custom.add' | translate"
                icon="pi pi-plus"
                [outlined]="true"
                size="small"
                type="button"
                [disabled]="availableForCustom().length === 0 && editingIndex() === null"
                data-test="packages-pricing-add-custom"
                (onClick)="openAddDialog()"
            />
        </p-tabpanel>
    </p-tabpanels>
</p-tabs>

@if (dialogVisible()) {
    <app-custom-pricing-dialog
        [availableEntities]="availableForCustom()"
        [defaultTiers]="defaultTierValues()"
        [editing]="editingValue()"
        (saveCustom)="saveCustom($event)"
        (cancelDialog)="closeDialog()"
    />
}
